import { defineStore } from 'pinia'
import { useAppStore } from "@/store/modules/app";

export const useProjectsStore = defineStore('projects', {
    state: () => ({
        projects: [],
        queryParams: {
            filter: {},
            order: {
                TITLE: 'ASC'
            }
        },
        pagination: {
            pages: 0,
            page: 1
        },
        selectedProject: {
            ID: null,
            TITLE: null
        }
    }),
    actions: {
        /**
         * Загрузка проектов
         *
         * @returns {Promise<void>}
         */
        loadProjects(context) {
            var $this = this,
                params = this.queryParams;

            params.page = this.pagination.page;

            return context.postToServer('/projects/getList', params, function (resp) {
                if (resp.data.result !== undefined) {
                    $this.projects = [...$this.projects, ...resp.data.result.items];
                    $this.pagination.pages = resp.data.result.pages;
                }

                return resp;
            });
        },
        /**
         * Добавление проекта
         *
         * @param fields
         * @param context
         */
        add(fields, context) {
            context.postToServer('/projects/add', {fields: fields}, function (resp) {
                if (!resp.data.error) {
                    const appStore = useAppStore()

                    appStore.listProjects.push({
                        ID: resp.data.result,
                        TITLE: fields.TITLE
                    })

                    context.$toast.add({severity: 'success', summary: 'Успешно', detail: 'Создан новый проект #' + resp.data.result, life: 3000})
                    context.$router.push('/projects/' + resp.data.result)
                } else {
                    context.$toast.add({ severity: 'error', summary: 'Ошибка', detail: resp.data.error, life: 3000 })
                }
            });
        },
        /**
         * Обновление проекта
         *
         * @param id
         * @param fields
         * @param context
         */
        update(id, fields, context) {
            context.postToServer('/projects/update/' + id, {fields: fields}, function (resp) {
                if (!resp.data.error) {
                    context.$toast.add({severity: 'success', summary: 'Успешно', detail: 'Обновлен проект #' + id, life: 3000});
                    context.$router.push('/projects/' + id);
                } else {
                    context.$toast.add({ severity: 'error', summary: 'Ошибка', detail: resp.data.error, life: 3000 });
                }
            });
        },
        /**
         * Удаление проекта по индексу
         *
         * @param index
         * @param context
         */
        deleteProjectByIndex(index, context) {
            if (index >= 0) {
                const $this = this;

                context.postToServer('/projects/delete/' + this.projects[index].ID, {}, function (resp) {
                    if (!resp.data.error) {
                        $this.projects.splice(index, 1);
                        context.$toast.add({severity: 'success', summary: 'Успешно', detail: 'Проект успешно удален', life: 3000});
                    } else {
                        context.$toast.add({ severity: 'error', summary: 'Ошибка', detail: resp.data.error, life: 3000 });
                    }
                });
            }
        }
    }
})